import { useLayoutEffect, useRef, type RefObject } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { DURATION, EASE } from '@constants/motion';
import { prefersReducedMotion } from '@lib/utils/motion';

/**
 * The page transition (the motion standard): when the path changes, the content area (`ref`, never the shell around
 * it) fades in and rises 6 px, once. Not on the first paint, not when going back or forward (a page returned to is
 * already known), not for a change of the query alone (filters, tabs, paging), nothing under reduced motion.
 */
export function usePageEntrance(ref: RefObject<HTMLElement | null>) {
  const { pathname } = useLocation();
  const how = useNavigationType();
  const first = useRef(true);
  useLayoutEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    const el = ref.current;
    if (!el || how === 'POP' || prefersReducedMotion() || typeof el.animate !== 'function') return;
    el.animate([{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }], { duration: DURATION.base, easing: EASE.out });
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps
}
